export default "__VITE_ASSET__270c68ec__"